var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "single_question" }, [
    _c("div", { staticClass: "question_title" }, [
      _c("span", [
        _vm._v(
          _vm._s(
            _vm.questionData.sectionName === undefined
              ? ""
              : _vm.questionData.sectionName
          )
        )
      ]),
      _vm._v(" "),
      _c("span", [
        _vm._v(
          "(" +
            _vm._s(
              _vm.questionData.sectionPrompt +
                " 本题" +
                _vm.questionData.score +
                "分。"
            ) +
            ")"
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "question_cont" }, [
      _c("div", { staticClass: "title", style: "height:" + _vm.height }, [
        _c("p", { staticClass: "q_num" }, [
          _vm._v("第" + _vm._s(_vm.questionData.orderSort + 1) + "题")
        ]),
        _vm._v(" "),
        _vm.questionData.questionContent
          ? _c("div", {
              staticClass: "editorShowArea ql-editor title_one",
              domProps: { innerHTML: _vm._s(_vm.questionData.questionContent) }
            })
          : _vm._e(),
        _vm._v(" "),
        _c("h1", {
          staticClass: "editorShowArea ql-editor",
          staticStyle: { overflow: "auto" },
          domProps: {
            innerHTML: _vm._s(_vm.questionData.questionDto.questionContent)
          }
        })
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "single_cont", style: "height:" + _vm.height },
        _vm._l(_vm.questionData.questionDto.childQuestions, function(
          data,
          index
        ) {
          return _c(
            "div",
            { key: index, staticClass: "single_item" },
            [
              _c("div", { staticClass: "num_title" }, [
                _c("span", [_vm._v(_vm._s(index + 1) + ".")]),
                _vm._v(" "),
                _c("div", {
                  staticClass: "test-title editorShowArea ql-editor",
                  domProps: { innerHTML: _vm._s(data.questionContent) }
                })
              ]),
              _vm._v(" "),
              _vm._l(data.items, function(v, i) {
                return _c(
                  "div",
                  { key: i, staticClass: "testCont" },
                  [
                    _c(
                      "el-checkbox",
                      {
                        staticClass: "single_radio",
                        on: {
                          change: function($event) {
                            return _vm.save(data, index)
                          }
                        },
                        model: {
                          value: _vm.checked[index][i],
                          callback: function($$v) {
                            _vm.$set(_vm.checked[index], i, $$v)
                          },
                          expression: "checked[index][i]"
                        }
                      },
                      [_vm._v(_vm._s(null))]
                    ),
                    _vm._v(" "),
                    _c("span", {
                      staticClass: "single_title editorShowArea ql-editor",
                      staticStyle: { float: "left", "margin-top": "15px" },
                      domProps: { innerHTML: _vm._s(v.itemKey) }
                    }),
                    _vm._v(" "),
                    _c("p", {
                      staticClass: "single_title editorShowArea ql-editor",
                      domProps: { innerHTML: _vm._s(v.itemValue) }
                    })
                  ],
                  1
                )
              })
            ],
            2
          )
        }),
        0
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8e74546a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8e74546a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/studyCenter/switch/testSumulationComponentNew/uncertain.vue
// module id = null
// module chunks = 